import styled, { css } from 'styled-components';

export const Message = styled.div`
  font-weight: bold;
`;

export const Container = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: center;
  gap: 5px;
  padding-top: 10px;
`;
